var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center mt-3"},[_c('p',[_vm._v("Welcome to the administration of the 'Robinize' application. This administration allows you to more easily manage the content on the application. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }